<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Employee Ratings
        </v-card-title>
        <v-divider></v-divider>
        <v-form ref="form" v-model="valid">
          <v-card-text class="subtitle-1">
            <v-row>
              <v-col cols="12">
                <v-btn
                  color="secondary"
                  text
                  class="light-background"
                  x-large
                  block
                  @click="addRow"
                >
                  <v-icon class="mr-2">add_circle</v-icon>
                  Add a rating
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-for="(rating, index) in annual_review_ratings"
                :key="index"
              >
                <v-text-field solo v-model="rating.title" hide-details>
                  <template v-slot:prepend-inner>
                    <span>{{ index + 1 }}.</span>
                  </template>
                  <template v-slot:append>
                    <v-btn icon @click="moveUp(index)" v-if="index > 0">
                      <v-icon>
                        keyboard_arrow_up
                      </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      @click="moveDown(index)"
                      v-if="index < totalRatingCount - 1"
                    >
                      <v-icon>
                        keyboard_arrow_down
                      </v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteRow(index)">
                      <v-icon>
                        delete
                      </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <info-card icon="wifi_tethering" title="What does this mean?">
                  The employee ratings you set here can be used by your managers
                  at the end of the annual review process. You can customize
                  these to fit your own internal rating system.
                </info-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="save" :loading="saving">Save Updates</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  name: "AnnualReviewRatings",
  data: () => ({
    saving: false,
    valid: false,
    loading: false
  }),
  computed: {
    totalRatingCount() {
      return this.annual_review_ratings.length;
    },
    ...mapGetters({
      annual_review_ratings: "settings/annual_review_ratings"
    })
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("settings/getAnnualReviewRatings")
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading your review ratings."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    moveUp(index) {
      if (index >= 0) {
        this.annual_review_ratings[
          index - 1
        ] = this.annual_review_ratings.splice(
          index,
          1,
          this.annual_review_ratings[index - 1]
        )[0];
      }
    },
    moveDown(index) {
      if (index >= 0) {
        this.annual_review_ratings[index] = this.annual_review_ratings.splice(
          index + 1,
          1,
          this.annual_review_ratings[index]
        )[0];
      }
    },
    addRow() {
      this.annual_review_ratings.push({
        sortOrder: this.annual_review_ratings.length + 1
      });
    },
    async deleteRow(index) {
      if (
        await this.$root.$confirm(
          "Delete rating",
          "Are you sure you want to delete this rating?",
          { color: "red" }
        )
      ) {
        if (index >= 0) {
          this.annual_review_ratings.splice(index, 1);
        }
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch(
            "settings/saveAnnualReviewRatings",
            this.annual_review_ratings
          )
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Annual Review Ratings saved");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving your annual review ratings."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
